import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import './Login.css'
import Header from './Header'
import LockIcon from './LockIcon'
import Environment from './env_var'
import DotSpinner from './Spinner'
import FooterPractice from './FooterPractice'
import ErrorHandling from './Error_Handling'

const Login = (props) => {
	const [data, setData] = useState(null)
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [requestingLogin, setRequestingLogin] = useState(false)
	const [successfulLogin, setSuccessfulLogin] = useState(false)
	const [isLoggedIn, setIsLoggedIn] = useState(false)
	const [checkingUserSession, setCheckingUserSession] = useState(true)
	const [userSessionActive, setUserSessionActive] = useState(false)
	const location = useLocation()
	
	const [error, setError] = useState(false)
	//const [errorName, setErrorName] = useState(null)
	const [errorCode, setErrorCode] = useState(null)
	const [errorMessage, setErrorMessage] = useState(null)
	const [redirectType, setRedirectType] = useState(null)
	const [redirectURL, setRedirectURL] = useState(null)
	

	const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
	: Environment.environment.stagingURL
	

	const handleErrorAcknowledge = () => {
		//error acknowledgement handling
		setError(false)
		setUserSessionActive(false)
	}
	
	const handleUsernameChange = (event) => {
		setUsername(event.target.value)
	}

	const handlePasswordChange = (event) => {
		setPassword(event.target.value)
	}

	const handleLoginRequest = () => {
		setRequestingLogin(true)
		setSuccessfulLogin(false)
		setError(false)
	}
	

	//set document title
	useEffect(() => {
		document.title = 'Login'
	}, [])


	//check for user session
	useEffect(() => {
		console.log('location')
		console.log(location)
		//if (location.state && !location.state.loginError) {
			const headers = {
				'Content-Type': 'application/json', 
				credentials: 'include'
			}

			fetch(`${fetchDomain}/rlm/mobile-apis/check_session.php`, {
				method: 'POST', 
				headers: headers
			})
			.then(response => response.json())
			.then(data => {
				if (data.httpResponse === 200) {
					setData(data)
					setCheckingUserSession(false)
					setUserSessionActive(true)
				} else {
					setCheckingUserSession(false)
					setUserSessionActive(false)

					//do not set error if user comes to login from another page
					//where they have already been the 403 "user not logged in"
					if (location.state && !location.state.loginError) {
						setError(true)
						setErrorCode(data.httpResponse)
						setErrorMessage(data.message)
						setRedirectURL(data.redirectURL)
						setRedirectType(data.redirectType)
					}
					
					//set up left and right skyscraper ads
					const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
					: Environment.environment.stagingURL
					document.getElementById('left-margin-ad').src = `${fetchDomain}${data.leftMarginAd}`
					document.getElementById('right-margin-ad').src = `${fetchDomain}${data.rightMarginAd}`
					//need to set display block in case user is paid subscriber and logged out
					document.getElementById('left-margin-ad').style.display = 'block'
					document.getElementById('right-margin-ad').style.display = 'block'
				}
			})
			.catch((error) => {
				setError(true)
				setErrorCode(500)
				setErrorMessage(error)
			})
		/*} else {
			setCheckingUserSession(false)
		}*/
	},[location])


	//send user's login credentials
	useEffect(() => {
		if (requestingLogin) {
			const data = JSON.stringify({
				env: Environment.environment.env,
				username: username,
				password: password
			})
			const headers = {
				'Content-Type': 'application/json', 
				credentials: 'include'
			}

			fetch(`${fetchDomain}/rlm/mobile-apis/login_api.php`, {
				method: 'POST', 
				headers: headers, 
				body: data
			})
			.then(response => response.json())
			.then(data => {
				if (data.httpResponse === 200) {
					setRequestingLogin(false)
					setSuccessfulLogin(true)
					setIsLoggedIn(true)
					setData(data)
				} else {
					setRequestingLogin(false)
					setSuccessfulLogin(false)
					setIsLoggedIn(false)
					setUsername('')
					setPassword('')
					setError(true)
					setErrorCode(data.httpResponse)
					setErrorMessage(data.message)
					setRedirectURL(data.redirectURL)
					setRedirectType(data.redirectType)
				}
			})
			.catch((error) => {
				setUsername('')
				setPassword('')
				setError(true)
				setErrorCode(500)
				setErrorMessage(error)
			})
		}
	},[requestingLogin])


	//allow laptop and desktop user to hit enter key
	//when entering login credentials
	const handleKeyPress = (e) => {
		if (e.charCode === 13) {
			if (e.target.name === 'username') {
				document.getElementById('password').focus()
			} else if (e.target.name === 'password') {
				handleLoginRequest()
			}
		}
	}

	useEffect(() => {
		console.log('****************')
		console.log('error: '+error)
		console.log('user session active: '+userSessionActive)
		console.log('requesting login: '+requestingLogin)
		console.log('checking user session: '+checkingUserSession)
		console.log('successful login: '+successfulLogin)
		console.log('****************')
	},[error, userSessionActive, requestingLogin, checkingUserSession, successfulLogin])


	if (error) {
		return (
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
				<ErrorHandling
					error={error} 
					errorCode={errorCode} 
					errorMessage={errorMessage}
					redirectType={redirectType}
					redirectURL={redirectURL}
					requestingLogin={false}
					handleErrorAcknowledge={handleErrorAcknowledge}
				/>
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	} else if (userSessionActive) {
		//route user to appropriate launchpad
		return (
			<Navigate 
				to={{
					pathname: data.isUserPreGuided === '1' ? '/launchpad':'/launchpad-guided',
				}}
				state={{
					isLoggedIn: true
				}} 
			/>
		)
	} else if (requestingLogin || checkingUserSession) {
		return (
			<React.Fragment>
				<Header isLoggedIn={isLoggedIn} />
					<DotSpinner />
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	} else {
		//show login
		return(
			<React.Fragment>
				{successfulLogin ? 
				<Navigate 
					to={{
						pathname: data.guidedPreferred === null ? '/launchpad-guided': data.guidedPreferred === true ? '/launchpad-guided':'/launchpad',
					}}
					state={{
						isLoggedIn: true
					}} 
				/> : null}
				<Header isLoggedIn={isLoggedIn} />
				<div className='login-container' >
					<LockIcon width='54px' height='54px' fill='red' opacity='0.5' />
					<h1>Sign In</h1>
					  <div className='form-container'>
					  <fieldset>
						<legend>Email</legend>
						<input 
							className='credentials' 
							type='text' 
							autoCapitalize='off'
							id='username' 
							name='username' 
							value={username} 
							onChange={(event) => handleUsernameChange(event)}
							onKeyPress={handleKeyPress} 
						/>
					  </fieldset>
					  <fieldset>
						<legend>Password</legend>
						<input 
							className='credentials' 
							type='password'
							id='password' 
							name='password' 
							value={password} 
							onChange={(event) => handlePasswordChange(event)}
							onKeyPress={handleKeyPress} 
						/>
					  </fieldset>
					  <button type='submit' name='submit' onClick={handleLoginRequest} >Sign In</button>
					  </div>
					<div className='recovery-container'>
						<a 
							className='recovery-signup' 
							href={`${fetchDomain}/manage/reset-pass-request.php`}>Forgot password?</a>
					</div>
					{/*error && <div className='login-error-handling-container'>
						<h1>{errorName}</h1>
						<p className='error-message'>{errorMessage}</p>
					</div>*/}
				</div>
				<FooterPractice view='launchpad' />
			</React.Fragment>
		)
	}
}

export default Login
